"use client";
import ChevronDown from "@/components/icons/ChevronDown";
import Col2 from "@/components/icons/Col2";
import Col4 from "@/components/icons/Col4";
import Button from "@/components/ui/Button";
import useDevice from "@/hooks/useDevice";
import { FilterModalProps } from "@/lib/centra/hooks/usePlp";
import {
  ITags,
  SortOrder,
} from "@/lib/centra/hooks/useProductFilter/useProductFilter";
import React from "react";
import FilterButton from "../PlpButtons/FilterButton";
import SortButton from "../PlpButtons/SortButton";
import PlpModal from "../PlpModal";
import FilterModalContent from "../PlpModal/components/FilterModalContent";
import SortModalContent from "../PlpModal/components/SortModalContent";
import styles from "./index.module.css";

type Props = {
  productCount?: number;
  tags?: ITags;
  gridSize: number;
  setGridSize: React.Dispatch<React.SetStateAction<number>>;
  sortOrder: SortOrder;
  filters: FilterModalProps;
};

const PlpTopBar = ({
  tags,
  setGridSize,
  gridSize,
  sortOrder,
  filters,
}: Props) => {
  const { mobile } = useDevice();

  return (
    <section className={styles.filters}>
      <div className={styles.wrap}>
        <div className={styles.filtersBar}>
          <FilterButton>
            <span className={styles.text}>
              <span>Passform</span>
              <ChevronDown />
            </span>
          </FilterButton>
          <PlpModal modal="filter" direction="left">
            <FilterModalContent filters={filters} />
          </PlpModal>
        </div>
        <div className={styles.colbuttons}>
          <Button
            mode="icon"
            className={styles.colIcon}
            title={mobile ? "Two columns" : "Four columns"}
            onClick={() => {
              setGridSize(4);
            }}
          >
            <Col4 isActive={gridSize === 4} />
          </Button>
          <Button
            className={styles.colIcon}
            mode="icon"
            title={mobile ? "Single column" : "Three columns"}
            onClick={() => {
              setGridSize(3);
            }}
          >
            <Col2 isActive={gridSize === 3} />
          </Button>
        </div>
        <div className={styles.sortBy}>
          <SortButton>
            <span className={styles.text}>
              <span>Sorter</span>
              <ChevronDown />
            </span>
          </SortButton>
          <PlpModal modal="sort" direction="right">
            <SortModalContent sortOrder={sortOrder} />
          </PlpModal>
        </div>
      </div>
    </section>
  );
};

export default PlpTopBar;
